import TableSys from "../generic/TableSys";

export default function Tableclients({ clients, handleLogo, handleUsers }) {


  const headCells = [
    { id: "nome_fantasia", numeric: false, label: "Nome Fantasia", order: 2 },
    { id: "razao_social", numeric: false, label: "Razão Social", order: 1 },
    { id: "pes_cpfcnpj", numeric: false, label: "CNPJ", order: 3 },
    { id: "cre_ativo", numeric: false, label: "Status", order: 4 },
    { id: "logos", numeric: false, label: "Logos", order: 5 },
    { id: "count_users", numeric: false, label: "Usuários", order: 6 },

  ];

  return <TableSys handleUsers={handleUsers} handleLogo={handleLogo} idPage={1} header={headCells} dados={clients}></TableSys>;
}

